import styled from 'styled-components'

export const StyledSystemDesignWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.bgBase};
  margin-bottom: -360px;

  .view-drawing {
    display: none;
  }

  .system-design-inner {
    padding-bottom: 398px;
    background: white;

    .system-design-title {
      width: 100%;
      text-align: center;
      font-style: normal;
      font-weight: normal;
      font-size: 28px;
      line-height: 42px;
      letter-spacing: 1px;
      color: #21213e;
      margin: 90px 0 35px 0;
    }
    .system-design-description {
      width: 1053px;
      margin: auto;
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 31px;
      text-align: center;
      color: #8992b1;
    }
  }

  .system-design-img-wrapper {
    width: fit-content;
    margin: auto;
    overflow: hidden;
    background: #ffffff;
    border: 0.714878px solid #e1e6ea;
    box-shadow: 0px 4.28927px 5.71902px rgba(29, 115, 232, 0.05);
    backdrop-filter: blur(19.4324px);
    border-radius: 16px;
    position: relative;
    top: -360px;
  }
  @media screen and (max-width: 640px) {
    margin-bottom: 0;
    .view-drawing {
      display: block;
      width: 175px;
      height: 45px;
      background: rgba(95, 77, 188, 0.2);
      border-radius: 10000px;
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
      line-height: 42px;
      text-align: center;
      color: ${({ theme }) => theme.colors.primary};
      margin: 35px auto 0 auto;
    }
    .system-design-img-wrapper {
      display: none;
    }

    .system-design-description {
      width: auto !important;
      padding: 0 38px;
      font-size: 17px !important;
    }

    .system-design-inner {
      padding-bottom: 92px !important;
    }
  }
`
